import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class FiltersOption extends BaseModel {
  static override constructorName = 'FiltersOption'

  id: string | number = ''
  name: string = ''
  isActive?: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(FiltersOption)
